/** @format */

import React from "react";
import { Search, ShoppingCart, Menu, X, Home, Palette } from "lucide-react";
import Link from "next/link";
import Image from "next/image";
import { StoreInterface } from "@/types/store";

interface NavbarHeaderProps {
  storeInfo: StoreInterface;
  cartQuantity: number;
  isMobileMenuOpen: boolean;
  onMobileMenuToggle: () => void;
  onSearchOpen: () => void;
}
export const NavbarHeader: React.FC<NavbarHeaderProps> = ({
  storeInfo,
  cartQuantity,
  isMobileMenuOpen,
  onMobileMenuToggle,
  onSearchOpen,
}) => {
  return (
    <div className="border border-border bg-background shadow-sm">
      <div className="container mx-auto py-4">
        <div className="flex items-center justify-between px-2">
          {/* Mobile Menu Button */}
          <div className="lg:hidden">
            <button
              onClick={onMobileMenuToggle}
              className="p-2 mr-2 rounded-xl hover:bg-muted transition-all duration-200"
              aria-label="Menu">
              {isMobileMenuOpen ? (
                <X className="h-6 w-6 text-primary" />
              ) : (
                <Menu className="h-6 w-6 text-primary" />
              )}
            </button>
          </div>

          {/* Logo */}
          <Link href="/" prefetch className="flex-shrink-0">
            <Image
              priority
              alt="Logo"
              src="/logo.png"
              width={70}
              height={70}
              className="w-[45px] h-[45px] sm:w-[60px] sm:h-[60px] object-contain hover:scale-105 transition-transform duration-300"
            />
          </Link>

          {/* Desktop Search */}
          <div className="hidden md:flex flex-1 max-w-2xl mx-8">
            <div className="relative w-full">
              <input
                type="text"
                placeholder="Tìm kiếm guitar cũ, phụ kiện..."
                className="
                  w-full px-6 py-3.5 pl-12
                  bg-background
                  border-2 border-border
                  rounded-full
                  focus:ring-2 focus:ring-ring
                  focus:border-primary
                  transition-all duration-300
                  text-foreground
                "
                onClick={onSearchOpen}
                readOnly
              />
              <Search className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-primary" />
              <button
                className="
                  absolute right-2 top-1/2 -translate-y-1/2
                  bg-primary text-primary-foreground
                  px-5 py-2 rounded-full
                  text-sm font-semibold
                  hover:opacity-90
                  transition-all duration-200
                ">
                Tìm
              </button>
            </div>
          </div>

          {/* Mobile Search */}
          <button
            onClick={onSearchOpen}
            className="
              md:hidden flex-1 mx-4 p-3
              bg-background
              border border-border
              rounded-xl
              hover:bg-muted
              transition-all duration-200
            "
            aria-label="Search">
            <div className="flex items-center gap-2">
              <Search className="h-5 w-5 text-primary" />
              <span className="text-sm text-muted-foreground">
                Tìm guitar...
              </span>
            </div>
          </button>

          {/* Mobile Cart */}
          <Link
            href="/gio-hang"
            prefetch
            className="
              sm:hidden relative p-2
              text-primary
              hover:bg-muted
              rounded-lg
              transition-all duration-300
              border border-border
            ">
            <ShoppingCart className="w-6 h-6" />

            {cartQuantity > 0 && (
              <span
                className="
                  absolute -top-2 -right-2
                  bg-destructive text-white text-xs
                  rounded-full w-6 h-6
                  flex items-center justify-center font-bold
                ">
                {cartQuantity > 99 ? "99+" : cartQuantity}
              </span>
            )}
          </Link>

          {/* Desktop Right */}
          <div className="hidden lg:flex items-center gap-4">
            <div
              className="
                flex items-center gap-2 px-5 py-2.5
                bg-muted
                rounded-full border border-border
                transition-all duration-300
              ">
              <Home className="w-5 h-5 text-primary" />
              <span className="text-sm text-muted-foreground">
                Showroom: 8:00 - 22:00
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
